import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { StatsEntity } from '../../domain/stats';

import { buildTransportOrdersFilters, StatsFilters } from '../../domain/statsFilters';
import { TransportOrdersFilters } from '../../domain/transportOrdersFilters';
import { useAuthentication } from '../../modules/auth/AuthenticationProvider';
import { BACKEND_URL } from '../backend-url';
import { SupportedCurrency } from '../../domain/currency';

const buildQueryParams = (filters: TransportOrdersFilters, currency: SupportedCurrency): URLSearchParams => {
    const params = new URLSearchParams();

    if (filters.orderMonthYearRange) {
        const { fromMonth, fromYear, toMonth, toYear } = filters.orderMonthYearRange;
        params.append('fromMonth', fromMonth.toString());
        params.append('fromYear', fromYear.toString());
        params.append('toMonth', toMonth.toString());
        params.append('toYear', toYear.toString());
    } else {
        console.error('No orderMonthYearRange provided');
    }

    if (filters.contractor) {
        params.append('contractorId', filters.contractor.id);
    }
    if (filters.creator) {
        params.append('creatorId', filters.creator.id);
    }
    params.append('forCurrency', currency);


    return params;
};

export const useStatsRepository = (filters: StatsFilters, currency: SupportedCurrency) => {
    const { getJwtToken } = useAuthentication();

    // Extract relevant data for query key based on the time period type
    const queryKey = ['stats', filters];

    const query = useQuery<StatsEntity>({
        queryKey,
        staleTime: 5 * 60 * 1000, // 5 minutes
        placeholderData: keepPreviousData,
        enabled: true,
        queryFn: async () => {
            const token = await getJwtToken();

            const normalizedFilters = buildTransportOrdersFilters(filters);
            const queryParams = buildQueryParams(normalizedFilters, currency);
            const response = await fetch(
                `${BACKEND_URL}/stats?${queryParams.toString()}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            if (!response.ok) {
                throw new Error(`${response.status}`);
            }

            return await response.json() as StatsEntity;
        },
    });

    return {
        ...query,
    };
};
    